import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

Vue.use(VueI18n)

const STORAGE_KEY = 'app_locale'
const SUPPORTED = ['zh-CN', 'en-US']

function normalizeLocale(raw) {
  if (!raw) return ''
  const val = String(raw).trim()
  if (SUPPORTED.includes(val)) return val
  if (val.startsWith('zh')) return 'zh-CN'
  if (val.startsWith('en')) return 'en-US'
  return ''
}

function getDefaultLocale() {
  const saved = normalizeLocale(window.localStorage.getItem(STORAGE_KEY))
  if (saved) return saved

  const browser = normalizeLocale(navigator.language || navigator.userLanguage)
  return browser || 'zh-CN'
}

export function setLocale(i18n, locale) {
  const next = normalizeLocale(locale) || 'zh-CN'
  if (i18n.locale === next) return
  i18n.locale = next
  window.localStorage.setItem(STORAGE_KEY, next)
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n

